var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolioComparison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h81v29H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h37v28H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1287",
    transform: "translate(-282 -1612)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282 1612)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 1626h228a8 8 0 0 1 8 8v16H294v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1626.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1634a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(304 1635)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294 1649h244v20H294z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M294.5 1649.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(304 1654)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(464 1657)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Portfolio Comparison",
    transform: "translate(310 1686)",
    fill: "#454545",
    fontSize: 10,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Portfolio Comparison")), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#e6e8e9",
    d: "M309.5 1696.5h214"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1252",
    transform: "translate(499.064 1676)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 24,
    height: 16,
    rx: 3,
    transform: "translate(-.064)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.936 10)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Next"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M310 1705h100v55H310z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(319 1715)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 83,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 80,
    height: 4,
    rx: 1,
    transform: "translate(0 15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 80,
    height: 4,
    rx: 1,
    transform: "translate(0 22)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 38,
    height: 4,
    rx: 1,
    transform: "translate(0 29)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1283",
    transform: "translate(0 39)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M310 1768h100v55H310z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 81,
    height: 4,
    rx: 1,
    transform: "translate(319 1778)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 20",
    transform: "translate(319 1787)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1787)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1779)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1771)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1763)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1284",
    transform: "translate(113 39)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M310 1768h100v55H310z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 81,
    height: 4,
    rx: 1,
    transform: "translate(319 1778)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 20",
    transform: "translate(319 1787)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1787)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1779)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1771)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1282",
    transform: "translate(-319 -1763)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 36,
    height: 4,
    rx: 1,
    transform: "translate(319 1787)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1560",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(374 1787)",
    fill: "#a6acb6",
    opacity: 0.7
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M423 1705h100v55H423z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(432 1715)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 83,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 80,
    height: 4,
    rx: 1,
    transform: "translate(0 15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 80,
    height: 4,
    rx: 1,
    transform: "translate(0 22)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 38,
    height: 4,
    rx: 1,
    transform: "translate(0 29)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1285"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1561",
    fill: "#fff",
    d: "M310 1765h100v41H310z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M337.864 1773.637a11.862 11.862 0 0 1 10.273 5.931 11.862 11.862 0 0 1 0 11.862l-2.073-1.193a9.472 9.472 0 0 0 0-9.472 9.472 9.472 0 0 0-8.2-4.739Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M348.137 1791.43a11.862 11.862 0 0 1-15.419 4.755l1.037-2.153a9.472 9.472 0 0 0 12.313-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M332.714 1796.185a11.862 11.862 0 0 1-5.9-15.021l2.224.873a9.472 9.472 0 0 0 4.708 11.995Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M326.818 1781.165a11.862 11.862 0 0 1 11.046-7.528v2.389a9.472 9.472 0 0 0-8.817 6.011Z",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 21",
    transform: "translate(363 1772)",
    clipPath: "url(#d)",
    fill: "#a6acb6"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    transform: "translate(0 16)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    transform: "translate(0 24)",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1286"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1561",
    fill: "#fff",
    d: "M423 1765h100v41H423z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M450.864 1773.637a11.862 11.862 0 0 1 10.273 5.931 11.862 11.862 0 0 1 0 11.862l-2.073-1.193a9.472 9.472 0 0 0 0-9.472 9.472 9.472 0 0 0-8.2-4.739Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M461.137 1791.43a11.862 11.862 0 0 1-15.419 4.755l1.037-2.153a9.472 9.472 0 0 0 12.313-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M445.714 1796.185a11.862 11.862 0 0 1-5.9-15.021l2.224.873a9.472 9.472 0 0 0 4.708 11.995Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M439.818 1781.165a11.862 11.862 0 0 1 11.046-7.528v2.389a9.472 9.472 0 0 0-8.817 6.011Z",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 21",
    transform: "translate(476 1772)",
    clipPath: "url(#d)",
    fill: "#a6acb6"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    transform: "translate(0 16)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1562",
    width: 37,
    height: 4,
    rx: 1,
    transform: "translate(0 24)",
    opacity: 0.7
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioComparison);
export default __webpack_public_path__ + "static/media/portfolio-comparison.03639a612e65ee8293967d614e2b354a.svg";
export { ForwardRef as ReactComponent };